import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=4682867a&scoped=true&"
import script from "./UsersEdit.vue?vue&type=script&lang=js&"
export * from "./UsersEdit.vue?vue&type=script&lang=js&"
import style0 from "./UsersEdit.vue?vue&type=style&index=0&id=4682867a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682867a",
  null
  
)

export default component.exports